var _path, _path2, _path3, _circle, _path4, _circle2, _path5, _ellipse, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailPanelBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 126,
    viewBox: "0 0 1440 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M635.402 71.5211C621.912 70.0112 614.418 86.5963 614.418 94.6495V108.239H679.994C677.746 107.862 680.744 104.615 673.249 94.6495C665.755 84.6837 658.385 90.4971 655.637 94.6495C653.139 87.8546 648.892 73.0311 635.402 71.5211Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M583.816 85.2915C570.208 84.3478 562.647 94.7135 562.647 99.7468V108.24H628.799C626.531 108.004 629.555 105.975 621.995 99.7468C614.435 93.5182 607 97.1515 604.228 99.7468C601.708 95.5 597.424 86.2353 583.816 85.2915Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.5 106.79H1590.2",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 302.956,
    cy: 51.1539,
    r: 25.1719,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.954 113.32V60.3063",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.942,
    cy: 61.8318,
    r: 25.1719,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M331.942 123.999V70.9851",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 552.74,
    cy: 75.0128,
    rx: 13.0999,
    ry: 21.9955,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M552.74 115.48V89.0095",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M443.963 101.382L443.963 106.921",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M484.585 94.9185V106.92",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M436.578 94.9185V106.92",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.231 94.9185V106.92",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.461 48.7977L212.78 2.82532L253 48.7977",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M181.489 50.986L194.259 36.3916V97.6881",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M216.513 1H313.93L343.484 39.6752",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M335.459 54.9991V94.0392",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 39.3105,
    width: 13.135,
    height: 13.8647,
    fill: "#CADDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 56.8234,
    width: 25.5402,
    height: 13.8647,
    fill: "#CADDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 76.5273,
    width: 13.135,
    height: 21.1619,
    fill: "#F3C477"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M246.798 53.9052V96.9587",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190.974 19.9723V1.72925H198.636V12.3102",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPanelBanner);
export default __webpack_public_path__ + "static/media/email-panel-banner.14caa6a2.svg";
export { ForwardRef as ReactComponent };